import * as React from 'react';
const SvgAttachmentDefault = (props) => (
  <svg
    width={44}
    height={44}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width={44} height={44} rx={6} fill="#F3F4F9" />
    <path
      d="M24 12.2695V16.4C24 16.9601 24 17.2401 24.109 17.454C24.2049 17.6421 24.3578 17.7951 24.546 17.891C24.7599 18 25.0399 18 25.6 18H29.7305M30 19.9882V27.2C30 28.8802 30 29.7202 29.673 30.362C29.3854 30.9265 28.9265 31.3854 28.362 31.673C27.7202 32 26.8802 32 25.2 32H18.8C17.1198 32 16.2798 32 15.638 31.673C15.0735 31.3854 14.6146 30.9265 14.327 30.362C14 29.7202 14 28.8802 14 27.2V16.8C14 15.1198 14 14.2798 14.327 13.638C14.6146 13.0735 15.0735 12.6146 15.638 12.327C16.2798 12 17.1198 12 18.8 12H22.0118C22.7455 12 23.1124 12 23.4577 12.0829C23.7638 12.1564 24.0564 12.2776 24.3249 12.4421C24.6276 12.6276 24.887 12.887 25.4059 13.4059L28.5941 16.5941C29.113 17.113 29.3724 17.3724 29.5579 17.6751C29.7224 17.9436 29.8436 18.2362 29.9171 18.5423C30 18.8876 30 19.2545 30 19.9882Z"
      fill="white"
    />
    <path
      d="M24 12.2695V16.4C24 16.9601 24 17.2401 24.109 17.454C24.2049 17.6421 24.3578 17.7951 24.546 17.891C24.7599 18 25.0399 18 25.6 18H29.7305M30 19.9882V27.2C30 28.8802 30 29.7202 29.673 30.362C29.3854 30.9265 28.9265 31.3854 28.362 31.673C27.7202 32 26.8802 32 25.2 32H18.8C17.1198 32 16.2798 32 15.638 31.673C15.0735 31.3854 14.6146 30.9265 14.327 30.362C14 29.7202 14 28.8802 14 27.2V16.8C14 15.1198 14 14.2798 14.327 13.638C14.6146 13.0735 15.0735 12.6146 15.638 12.327C16.2798 12 17.1198 12 18.8 12H22.0118C22.7455 12 23.1124 12 23.4577 12.0829C23.7638 12.1564 24.0564 12.2776 24.3249 12.4421C24.6276 12.6276 24.887 12.887 25.4059 13.4059L28.5941 16.5941C29.113 17.113 29.3724 17.3724 29.5579 17.6751C29.7224 17.9436 29.8436 18.2362 29.9171 18.5423C30 18.8876 30 19.2545 30 19.9882Z"
      stroke="#6D659D"
      strokeWidth={1.2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      opacity={0.12}
      d="M28.8213 17.1338H25.8672C25.5772 17.1338 25.3955 17.1332 25.2588 17.1221C25.1943 17.1168 25.1531 17.1096 25.127 17.1035L25.085 17.0898C25.0287 17.0611 24.9803 17.0195 24.9434 16.9688L24.9102 16.915C24.9059 16.9067 24.8885 16.8707 24.8779 16.7412C24.8668 16.6045 24.8662 16.4228 24.8662 16.1328V13.1787L28.8213 17.1338Z"
      fill="#6D659D"
      stroke="#6D659D"
      strokeWidth={1.2}
    />
  </svg>
);
export default SvgAttachmentDefault;
